import { Button, Modal, Switch } from "@deligoo/ui"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { shallowEqual, useDispatch } from "react-redux"

import { useAppSelector } from "@/App"
import { selectTeams, setCurrentMultiTeams } from "@/store/teams"
import { Team } from "@/types"
import { isProductionEnvironment } from "@/utils"

import cls from "./MultiTeamSelectModal.module.scss"

export const MultiTeamSelectModal = ({ setIsOpen }: { setIsOpen: (isOpen: boolean) => void }) => {
  const teams = useAppSelector(selectTeams, shallowEqual)
  const multiTeams = useAppSelector((state) => state.teams.currentMulti, shallowEqual)

  const [areTestTeamsShown, showTestTeams] = useState(!isProductionEnvironment)

  const filteredTeams = areTestTeamsShown ? teams : teams.filter((team) => !team.is_test)

  const { t } = useTranslation()

  const dispatch = useDispatch()

  function handleOptionClick(teamUuid: Team["uuid"]) {
    if (!multiTeams) return

    const isAlreadySelected = multiTeams.some((selectedTeam) => selectedTeam.uuid === teamUuid)

    if (isAlreadySelected) {
      dispatch(setCurrentMultiTeams(multiTeams.filter((selectedTeam) => selectedTeam.uuid !== teamUuid)))
    } else {
      const teamToSelect = teams.find((team) => team.uuid === teamUuid)

      if (teamToSelect) dispatch(setCurrentMultiTeams([...multiTeams, teamToSelect]))
    }
  }

  return (
    <Modal handleClose={() => setIsOpen(false)} className={cls.modal} closeBtnPosition="inside">
      <Modal.Header>
        <Modal.Title>{t("select_teams")}:</Modal.Title>
        <Switch onClick={() => showTestTeams((areShown) => !areShown)} defaultChecked={areTestTeamsShown}>
          {t("show_test_teams")}
        </Switch>
      </Modal.Header>
      <Modal.Content>
        <div className={cls.teamsList}>
          {filteredTeams.map((team) => {
            const isSelected = multiTeams.some((selectedTeam) => selectedTeam.uuid === team.uuid)

            return (
              <Button
                key={team.uuid}
                onClick={() => handleOptionClick(team.uuid)}
                color={isSelected ? "primary" : undefined}
                raised={isSelected}
                fullWidth
              >
                {team.name}
              </Button>
            )
          })}
        </div>
      </Modal.Content>
    </Modal>
  )
}
